import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class CustomIconsService {
  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
  ) {}

  registerSvgIcon(svgText: string, iconCustomName: string) {
    const safeSvg = this.sanitizer.bypassSecurityTrustHtml(svgText);
    this.iconRegistry.addSvgIconLiteral(iconCustomName, safeSvg);
  }
}
